
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_cvci4_149",
  "tools": "awsui_tools_wih1l_cvci4_160",
  "tools-filtering": "awsui_tools-filtering_wih1l_cvci4_169",
  "tools-align-right": "awsui_tools-align-right_wih1l_cvci4_182",
  "tools-clear-sort": "awsui_tools-clear-sort_wih1l_cvci4_186",
  "tools-pagination": "awsui_tools-pagination_wih1l_cvci4_189",
  "tools-preferences": "awsui_tools-preferences_wih1l_cvci4_189",
  "tools-small": "awsui_tools-small_wih1l_cvci4_195",
  "table": "awsui_table_wih1l_cvci4_199",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_cvci4_205",
  "wrapper": "awsui_wrapper_wih1l_cvci4_209",
  "variant-stacked": "awsui_variant-stacked_wih1l_cvci4_216",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_cvci4_216",
  "variant-container": "awsui_variant-container_wih1l_cvci4_216",
  "has-footer": "awsui_has-footer_wih1l_cvci4_219",
  "has-header": "awsui_has-header_wih1l_cvci4_222",
  "cell-merged": "awsui_cell-merged_wih1l_cvci4_239",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_cvci4_251",
  "empty": "awsui_empty_wih1l_cvci4_267",
  "loading": "awsui_loading_wih1l_cvci4_271",
  "selection-control": "awsui_selection-control_wih1l_cvci4_280",
  "selection-control-header": "awsui_selection-control-header_wih1l_cvci4_287",
  "selection-control-content-spans-rows": "awsui_selection-control-content-spans-rows_wih1l_cvci4_292",
  "header-secondary": "awsui_header-secondary_wih1l_cvci4_299",
  "variant-full-page": "awsui_variant-full-page_wih1l_cvci4_310",
  "table-has-header": "awsui_table-has-header_wih1l_cvci4_316",
  "header-controls": "awsui_header-controls_wih1l_cvci4_327",
  "variant-embedded": "awsui_variant-embedded_wih1l_cvci4_336",
  "variant-borderless": "awsui_variant-borderless_wih1l_cvci4_336",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_cvci4_341",
  "footer": "awsui_footer_wih1l_cvci4_341",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_cvci4_349",
  "footer-pagination": "awsui_footer-pagination_wih1l_cvci4_357",
  "thead-active": "awsui_thead-active_wih1l_cvci4_361",
  "row": "awsui_row_wih1l_cvci4_362",
  "row-selected": "awsui_row-selected_wih1l_cvci4_363",
  "skeleton-loading-cell": "awsui_skeleton-loading-cell_wih1l_cvci4_367"
};
  